var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditsCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.76 42.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#520989;}.cls-2,.cls-3{fill:none;stroke:#4fddc6;stroke-linecap:round;stroke-miterlimit:10;}.cls-2{stroke-width:3.42px;}.cls-3{stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 65.76,
    height: 42.6,
    rx: 5.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.71,
    y1: 32.89,
    x2: 17.26,
    y2: 32.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 22.39,
    y1: 32.89,
    x2: 30.94,
    y2: 32.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 36.06,
    y1: 32.89,
    x2: 44.61,
    y2: 32.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 49.74,
    y1: 32.89,
    x2: 58.29,
    y2: 32.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.3,
    y1: 13.89,
    x2: 56.94,
    y2: 13.89
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditsCard);
export default __webpack_public_path__ + "static/media/CreditsCard.2a9450d3cc89071ce56f96efaff03c6d.svg";
export { ForwardRef as ReactComponent };